import React, { useContext } from 'react';
import { useSidebarFilterOptionsContext } from '../../../energyUsageData/sidebar/context/SidebarFilterOptionsContext';
import { CollapseFilterWrapper } from '../../../../components/sidebar-filters/CollapseFilterWrapper';
import { CompanyFilterSelect } from '../../../../components/sidebar-filters/filter-select/CompanyFilterSelect';
import { AgreementStatusFilterSelect } from '../../../../components/sidebar-filters/filter-select/AgreementStatusFilterSelect';
import { IntervalDataSourceFilterSelect } from '../../../../components/sidebar-filters/filter-select/IntervalDataSourceFilterSelect';
import {
    IAgreementStatusesSidebarFilters,
    IAgreementStatusesSidebarFiltersContext,
    AgreementStatusesSidebarFiltersContext,
} from './AgreementStatusesSidebarFiltersContext';

export const AgreementStatusesFilterKeys = {
    // Filters
    agreement_status: 'agreementStatus',
    company_id: 'companyId',
    source: 'source',
} as const;

export type TAgreementStatusesFilterKey = (typeof AgreementStatusesFilterKeys)[keyof typeof AgreementStatusesFilterKeys];

export const AgreementStatusesFilterLabels = {
    [AgreementStatusesFilterKeys.agreement_status]: 'Agreement Status',
    [AgreementStatusesFilterKeys.company_id]: 'Company',
    [AgreementStatusesFilterKeys.source]: 'Source',
} as const;

interface IAgreementStatusesSidebarFiltersProps {
    onFilterChange: (filters: IAgreementStatusesSidebarFilters) => void;
}

export const AgreementStatusesSidebarFilters: React.FC<IAgreementStatusesSidebarFiltersProps> = ({ onFilterChange }) => {
    const { filters, handleFilterChange } = useContext<IAgreementStatusesSidebarFiltersContext>(AgreementStatusesSidebarFiltersContext);
    const { isLoading: isFiltersLoading, allCompaniesOptions, agreementStatusOptions, intervalDataSourceOptions } = useSidebarFilterOptionsContext();

    const handleAgreementStatusesFilterChange = (key: string, value: unknown) => {
        handleFilterChange(key, value);
        onFilterChange({ ...filters, [key]: value });
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', overflowY: 'auto' }}>
            {/* Filters */}
            <CollapseFilterWrapper label="Filters">
                <AgreementStatusFilterSelect
                    height={160}
                    label={AgreementStatusesFilterLabels[AgreementStatusesFilterKeys.agreement_status]}
                    value={filters[AgreementStatusesFilterKeys.agreement_status] || null}
                    onChange={value => handleAgreementStatusesFilterChange(AgreementStatusesFilterKeys.agreement_status, value)}
                    options={agreementStatusOptions}
                />
                <CompanyFilterSelect
                    label={AgreementStatusesFilterLabels[AgreementStatusesFilterKeys.company_id]}
                    value={filters[AgreementStatusesFilterKeys.company_id] || []}
                    onChange={value => handleAgreementStatusesFilterChange(AgreementStatusesFilterKeys.company_id, value)}
                    options={allCompaniesOptions}
                    isLoading={isFiltersLoading}
                />
                <IntervalDataSourceFilterSelect
                    label={AgreementStatusesFilterLabels[AgreementStatusesFilterKeys.source]}
                    value={filters[AgreementStatusesFilterKeys.source] || []}
                    onChange={value => handleAgreementStatusesFilterChange(AgreementStatusesFilterKeys.source, value)}
                    options={intervalDataSourceOptions}
                />
            </CollapseFilterWrapper>
        </div>
    );
};
